'use strict';

var isProduction = process.env.NODE_ENV === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
}

module.exports = invariant;



//////////////////
// WEBPACK FOOTER
// ./~/tiny-invariant/dist/tiny-invariant.cjs.js
// module id = 790
// module chunks = 0